import { render } from "./DeveloperListStyle.vue?vue&type=template&id=656c3d53"
import script from "./DeveloperListStyle.vue?vue&type=script&lang=js"
export * from "./DeveloperListStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__